var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RpaTitle"},[_c('h1',{staticClass:"zhTitle"},[_vm._v(_vm._s(_vm.zh))]),_c('p',{staticClass:"enTitle"},[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }